// Cargo capacity of a fleet about to leave (the server sums `ships.<class>.cargo × count` the same way).
import type { FullSystem, ShipType } from '@stars-and-ships/api-types';

export function cargoCapacity(
  ships: { shipType: ShipType; count: number }[],
  options: FullSystem['shipOptions']
): number {
  return ships.reduce((sum, s) => sum + (options[s.shipType]?.cargo ?? 0) * s.count, 0);
}
